<template>
  <v-container fluid>
    <v-dialog
      v-model="createDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>Create Warehouse</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newWarehouse.name"
            label="Name"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="createDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!newWarehouse.name || !newWarehouse.name.trim()"
            @click="createWarehouse"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
      color="primary"
      text
      @click="createDialog = true"
    >
      New Warehouse
    </v-btn>
    <v-simple-table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Active</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="warehouse in warehouses"
          :key="warehouse.warehouseId"
        >
          <td>
            <v-text-field
              v-model="warehouse.name"
              hide-details
            />
          </td>
          <td>
            <v-switch
              v-model="warehouse.active"
              hide-details
            />
          </td>
          <td>
            <v-btn
              color="primary"
              text
              @click="saveWarehouse(warehouse)"
            >
              Save
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'WarehouseList',
  data: () => ({
    createDialog: false,
    warehouses: [],
    newWarehouse: {
      name: '',
      active: true,
    },
  }),
  created() {
    this.getWarehouses();
  },
  methods: {
    ...mapActions('apiClient', ['get', 'create', 'update']),
    getWarehouses() {
      this.get({ url: '/warehouses' }).then((response) => {
        this.warehouses = response.data;
      });
    },
    createWarehouse() {
      this.create({ url: '/warehouses', body: this.newWarehouse }).then(() => {
        this.createDialog = false;
        this.newWarehouse = { name: '', active: true };
        this.getWarehouses();
      });
    },
    saveWarehouse(warehouse) {
      this.update({
        url: '/warehouses',
        id: warehouse.warehouseId,
        body: warehouse,
      }).then(() => this.getWarehouses());
    },
  },
};
</script>
